import React from 'react';
import Card from '../Card';
import { Trans } from '@lingui/macro';

export default function ChangingTurnAnimated(props) {
  let cards_applying = [];
  for (let [index, card_type] of props.cards.entries()) {
    cards_applying.push(<Card key={`card-${index}`} type={card_type} animating={true} movementType="applying-keep-cards" />);
  }

  return <div>
    <p className="applying-keep-cards-player-name"><Trans>{props.playerName}'s Passive Cards triggered</Trans></p>
    {cards_applying}
  </div>;
}
